"use client";

import { useLanguage } from "../../context/LanguageContext";
import { Header } from "../Header";
import SiteFooter from "../SiteFooter";
import AboutSection from "../sections/AboutSection";

export default function AboutPage(): JSX.Element {
  const { t } = useLanguage();

  return (
    <div className="flex min-h-screen flex-col" dir={t.common.dir} lang={t.common.lang}>
      <Header />
      <main className="flex-1">
        <AboutSection headingLevel="h1" />
      </main>
      <SiteFooter />
    </div>
  );
}
